// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-style {
  width: 100%;
}

::ng-deep .dc--btn-tertiary.p-button:enabled:hover {
  background: none;
  color: #0d0d11;
  font-weight: 900;
  border-color: none;
}

::ng-deep .p-dropdown {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/organization-creation-form/organization-creation-form.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAII;EACI,sBAAA;AADR","sourcesContent":[".form-style {\n    width: 100%;\n}\n\n::ng-deep .dc--btn-tertiary.p-button:enabled:hover {\n    background: none;\n    color: #0d0d11;\n    font-weight: 900;\n    border-color: none;\n\n}\n\n::ng-deep {\n    .p-dropdown {\n        width: 100% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
